import React, { useEffect, useState } from "react";
import { Spin } from "antd";

import { Tabs, Typography } from "antd";
import Swal from "sweetalert2";
import PPIService from "../../services/PPIService";

import CardComponent from "./CardComponent";
import CardManagement from "./CardManagement";

import "./Card.css";
import Header from "../../components/Header";
import Footer from "../../components/Footer";

const { Title, Text } = Typography;
const { TabPane } = Tabs;

const Dashboard = () => {
  const [loading, setLoading] = useState(false);
  const [limit, setLimit] = useState(10000);
  const [ecommEnabled, setEcommEnabled] = useState(true);
  const [activeTab, setActiveTab] = useState("limit");

  useEffect(() => {
    fetchCardDetails();
    // fetchCardBalance();
  }, []);

  const [cardOrderStatus, setCardOrderStatus] = useState(false);
  const [cardDetails, setCardDetails] = useState();

  const fetchCardDetails = async () => {
    setLoading(true);
    try {
      const result = await PPIService.getCardDetails();

      if (!result.success) {
        Swal.fire("Oops!", result.message || "Failed to fetch", "error");
        return;
      }

      const responseData = result.data;

      if (responseData.status === "SUCCESS") {
        const data = responseData.data;

        setCardDetails(data);
        setCardOrderStatus(data?.card_order_status);
        fetchCardBalance();
      } else {
        if (responseData.message === "CARD_ISSUANCE_PENDING") {
          setCardOrderStatus("PENDING");
        } else {
          Swal.fire("Oops!", responseData.message, "error");
        }
      }
    } catch (error) {
      Swal.fire(
        "Oops!",
        error.response?.data?.message || error.message || "Request Failed",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  const [cardBalance, setCardBalance] = useState();

  const fetchCardBalance = async () => {
    setLoading(true);
    try {
      const result = await PPIService.getCardBalance();

      if (!result.success) {
        Swal.fire("Oops!", result.message || "Failed to fetch", "error");
        return;
      }

      const responseData = result.data;

      if (responseData.status === "SUCCESS") {
        const data = responseData.data;

        setCardBalance(data);
      } else {
        Swal.fire("Oops!", responseData.message, "error");
      }
    } catch (error) {
      Swal.fire(
        "Oops!",
        error.response?.data?.message || error.message || "Request Failed",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="position-relative">
      {loading && (
        <div
          className="d-flex justify-content-center align-items-center position-absolute top-0 start-0 w-100 h-100"
          style={{ backgroundColor: "rgba(255,255,255,0.7)", zIndex: 9999 }}
        >
          <Spin size="large" tip="Loading..." />
        </div>
      )}

      <Header />

      <div
        className="bg-light py-3 d-flex justify-content-center"
        style={{
          paddingLeft: window.innerWidth <= 768 ? "0px" : "1rem",
          paddingRight: window.innerWidth <= 768 ? "0px" : "1rem",
        }}
      >
        <div
          className="card w-100"
          style={{
            maxWidth: "1200px",
            minHeight: "800px",
            borderRadius: "0px", // explicitly no rounding
          }}
        >
          <div className="card-body p-3">
            <div className="row justify-content-center p-1">
              {/* Optional Prepaid Card Section */}
            </div>

            {cardOrderStatus !== "PENDING" && (
              <div className="row g-3 pt-2 pb-2 justify-content-center">
                <div className="px-2">
                  <CardComponent
                    loading={loading}
                    cardBalance={cardBalance}
                    cardDetails={cardDetails}
                    fetchCardBalance={fetchCardBalance}
                    fetchCardDetails={fetchCardDetails}
                  />
                </div>
                <div className="col-md-12">
                  <CardManagement
                    cardBalance={cardBalance}
                    cardDetails={cardDetails}
                    fetchCardBalance={fetchCardBalance}
                    fetchCardDetails={fetchCardDetails}
                  />
                </div>
              </div>
            )}

            {cardOrderStatus == "PENDING" && (
              <div className="row g-4 justify-content-center">
                <div className="text-center">
                  <div className="text-center">
                    <div
                      className="spinner-border text-primary mb-3"
                      role="status"
                    >
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    <p className="mb-0 fw-semibold">
                      Virtual prepaid card issuance is in progress. Please wait
                      a few minutes.
                    </p>
                  </div>
                  <p className="text-warning"></p>

                  <hr className="my-4" />
                  <div className="text-center">
                    <small className="text-muted d-block mb-1">ISSUED BY</small>
                    <img
                      src="/images/pine-labs-logo.png"
                      alt="Pine Labs"
                      style={{ height: "22px" }}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Dashboard;
